import React from 'react'
import { Trash2, AlertTriangle } from 'lucide-react'
import Button from '@/components/common/Button'

interface DeleteProjectDialogProps {
  isOpen: boolean
  projectName: string
  onConfirm: () => void
  onCancel: () => void
  isDeleting?: boolean
}

const DeleteProjectDialog: React.FC<DeleteProjectDialogProps> = ({
  isOpen,
  projectName,
  onConfirm,
  onCancel,
  isDeleting = false
}) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        {/* Header */}
        <div className="flex items-start space-x-3 mb-4">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-6 w-6 text-red-600" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900">
              Delete Project
            </h3>
            <p className="text-sm text-gray-500 mt-1">
              This action cannot be undone
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-gray-700">
            Are you sure you want to delete <strong>"{projectName}"</strong>?
          </p>
          <p className="text-sm text-gray-600 mt-2">
            This will permanently delete:
          </p>
          <ul className="list-disc list-inside text-sm text-gray-600 mt-2 space-y-1">
            <li>All segments and translations</li>
            <li>Project statistics and metadata</li>
            <li>Any uploaded source files</li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex space-x-3">
          <Button
            variant="danger"
            onClick={onConfirm}
            disabled={isDeleting}
            leftIcon={isDeleting ? undefined : <Trash2 className="h-4 w-4" />}
            className="flex-1"
          >
            {isDeleting ? 'Deleting...' : 'Delete Project'}
          </Button>
          <Button
            variant="secondary"
            onClick={onCancel}
            disabled={isDeleting}
            className="flex-1"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DeleteProjectDialog